import React from "react";
import { Link } from "react-router-dom";
import { SelectListGroup } from "../../../common";
import * as style from "../styles.module.scss";

const SelectField = ({
  handleChange,
  options,
  selectedCode,
  id,
  title,
  validation,
}) => (
  <div className="form-group">
    <label htmlFor="title">{title}</label>
    <SelectListGroup
      id={id}
      value={selectedCode}
      onChange={(e) => {
        handleChange(id, e.target.value);
      }}
      options={[{ label: "-- Please select --", value: "" }, ...options]}
      classes="register_field register_field-dropdown"
      isError={!!validation}
    />
    {validation && (
      <span className="text_invalid fontSize-12 text-danger">{validation}</span>
    )}
  </div>
);
const Demographics = ({
  state,
  errors,
  handleState,
  handleSubmit,
  navigateBackPath,
  nationalityOptions,
  sexualOrientationOptions,
  ethnicityOptions,
  genderOptions,
}) => {
  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleSubmit}
    >
      <div>
        <SelectField
          handleChange={handleState}
          options={nationalityOptions}
          selectedCode={state.nationalityCode}
          id="nationalityCode"
          title="Nationality*"
          validation={errors.nationalityCode}
        />
        <SelectField
          handleChange={handleState}
          options={genderOptions}
          selectedCode={state.gender}
          id="gender"
          title="Sex*"
          validation={errors.gender}
        />
        <SelectField
          handleChange={handleState}
          options={sexualOrientationOptions}
          selectedCode={state.sexualOrientationCode}
          id="sexualOrientationCode"
          title="Sexual orientation*"
          validation={errors.sexualOrientationCode}
        />
        <SelectField
          handleChange={handleState}
          options={ethnicityOptions}
          selectedCode={state.ethnicityCode}
          id="ethnicityCode"
          title="Ethnicity*"
          validation={errors.ethnicityCode}
        />
      </div>
      <div className={`mt-lg-auto mb-lg-2 ${style.actions}`}>
        <Link to={navigateBackPath}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <button className="btn btn-primary btn-block" type="submit">
          Next
        </button>
      </div>
    </form>
  );
};

export default Demographics;
